
(() => {
  function initProductZoom() {
    const isProductPage =
      window.location.pathname.includes('/products/');

    if (!isProductPage) return;

    document.querySelectorAll(
      'product-media, .product-media-container, .product__media, .product-media'
    ).forEach((container) => {
      const img = container.querySelector('img');

      if (!img || container.dataset.cjZoomReady) return;
      container.dataset.cjZoomReady = 'true';

      container.style.setProperty('overflow', 'hidden', 'important');
      container.style.setProperty('cursor', 'crosshair', 'important');

      container.addEventListener('mousemove', (e) => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        const rect = container.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;

        const zoom = 2.2;
        const moveX = (0.5 - x) * rect.width * (zoom - 1);
        const moveY = (0.5 - y) * rect.height * (zoom - 1);

        img.style.setProperty(
          'transform',
          `translate(${moveX}px, ${moveY}px) scale(${zoom})`,
          'important'
        );
        img.style.setProperty('transform-origin', 'center', 'important');
      });

      container.addEventListener('mouseleave', () => {
        img.style.removeProperty('transform');
        img.style.removeProperty('transform-origin');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductZoom);
  } else {
    initProductZoom();
  }

  document.addEventListener('shopify:section:load', initProductZoom);
})();